import { SvgIconProps } from './icon-props';

export default function DivingSnorkeling({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			width={width}
			height={height}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M24.381 10.533v-7.14a1.279 1.279 0 1 0-2.55 0v6.41H9.941a.739.739 0 0 0-.21 0 3.79 3.79 0 0 0-3.73 3.848v3.782c0 .16.06 3.89 5.76 3.89 1 0 1.5-.95 2-2s.95-1.78 1.74-1.78h.93c.79 0 1.23.75 1.74 1.79s1 1.95 2 1.95a9.933 9.933 0 0 0 1.62-.13v4.28a2.18 2.18 0 0 1-4.35.2h.82a.37.37 0 0 0 .37-.37v-3.53a.37.37 0 0 0-.36-.38h-4.21a.38.38 0 0 0-.37.38v3.52a.38.38 0 0 0 .37.38h.75a4.79 4.79 0 0 0 9.57-.07v-5.31a3.68 3.68 0 0 0 1.62-2.82v-3.94a3.81 3.81 0 0 0-1.62-2.96zm-1.28-7.67a.53.53 0 0 1 .53.53v6.71a3.759 3.759 0 0 0-1.05-.26v-6.45a.52.52 0 0 1 .51-.53h.01zm-8.66 19.24h3.48v2.82h-3.48v-2.82zm9.19 3.367a4.035 4.035 0 0 1-8.07.068h1.17a2.918 2.918 0 0 0 5.82.058c.005-.053 0-.076 0-.126v-4.433c.36-.09.711-.21 1.05-.36l.03 4.793zm1.37-8.037c0 .11-.08 2.89-4.76 2.89-.41 0-.75-.68-1.13-1.44-.45-.92-1.13-2.3-2.61-2.3h-.93c-1.46 0-2.14 1.35-2.63 2.33-.49.98-.72 1.41-1.11 1.41-4.72 0-4.83-2.78-4.83-2.89v-3.76a2.79 2.79 0 0 1 2.708-2.87h12.382A2.78 2.78 0 0 1 25 13.45l.002.064v3.92z"
				fill="#000"
			/>
		</svg>
	);
}
